import { Directive, ElementRef, HostBinding, Input } from '@angular/core'

// eslint-disable-next-line @angular-eslint/directive-selector -- native option selector
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector -- native option selector
    selector: 'select > option[value]',
    standalone: false,
})
export class SelectOptionDirective {
    @Input()
    @HostBinding('value')
    public value: any

    constructor(
        public el: ElementRef<HTMLOptionElement>,
    ) {
    }
}
